export { default } from "./AverageTimeToCloseStatistics";
